import { render, staticRenderFns } from "./TeamChecks.vue?vue&type=template&id=08047bd8&scoped=true"
import script from "./TeamChecks.vue?vue&type=script&lang=js"
export * from "./TeamChecks.vue?vue&type=script&lang=js"
import style0 from "./TeamChecks.vue?vue&type=style&index=0&id=08047bd8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08047bd8",
  null
  
)

export default component.exports